var React = require('react');

function LogoSquare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","opacity":"0.5","d":"M100 63.91c0-5.5-3.9-12.25-8.66-15L8.66 1.17C3.9-1.58 0 .67 0 6.17v210.94c0 5.5 3.9 12.25 8.66 15l82.68 47.74c4.76 2.75 8.66.5 8.66-5z","key":0}),React.createElement("path",{"fill":"#fff","d":"M191.34 116.64c4.76-2.75 4.76-7.25 0-10L8.66 1.17C3.9-1.58 0 .67 0 6.17v210.94c0 5.5 3.9 7.75 8.66 5l182.68-105.47c4.76-2.75 4.76-7.25 0-10L8.66 1.17C3.9-1.58 0 .67 0 6.17v210.94c0 5.5 3.9 7.75 8.66 5z","key":1})]);
}

LogoSquare.defaultProps = {"viewBox":"0 0 194.91 281.02"};

module.exports = LogoSquare;

LogoSquare.default = LogoSquare;
